import { render, staticRenderFns } from "./SavePropertyModal.vue?vue&type=template&id=512a2ea4&"
import script from "./SavePropertyModal.vue?vue&type=script&lang=js&"
export * from "./SavePropertyModal.vue?vue&type=script&lang=js&"
import style0 from "./SavePropertyModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports